import {Backend} from '@common/backend'
import {globals} from '@extensions/globals-base'
import {
  DataObjectId,
  Hub,
  ObjectType,
  Workflow,
  Workflows,
  workflowToConfig
} from 'yougile-model'
import {ObjUtil} from 'yougile-util'
import {Sync} from './sync'

export class WorkflowClient {
  static get(workflowId: string): Workflow {
    const all = this.getCompanyWorkflows()
    return all[workflowId]
  }

  static getCompanyWorkflows(): {[id: string]: Workflow} {
    const box = Sync.getCurrentSandbox()
    const company = box.getHub(box.companyId)
    return company?.data.workflows ?? {}
  }

  static getBoardWorkflows(
    boardId: DataObjectId,
    allWorkflows?: {[id: string]: Workflow}
  ): Workflow[] {
    const workflows = allWorkflows ?? this.getCompanyWorkflows()

    const res: Workflow[] = []
    for (const w of ObjUtil.values(workflows)) {
      if (w.boards.includes(boardId)) {
        res.push(w)
      }
    }
    return res
  }

  static async runAction(params: {
    workflowId: string
    actionId: string
    taskId?: DataObjectId
    inputs: unknown
  }): Promise<void> {
    await Backend.postJSON('/data/workflows/action', {
      ...Backend.loadCred(),
      companyId: globals.getCompanyId(),
      ...params
    })
  }

  static isDisallowedByRestriction(
    hub: Hub | undefined,
    restriction: Workflows.Restriction,
    onlyCheckObjectType: ObjectType = 'task'
  ): boolean {
    if (!hub) {
      return false
    }
    const box = Sync.get(hub)
    const type = box.getType(hub)
    if (type === 'column') {
      return (
        onlyCheckObjectType === 'column' &&
        this.isDisallowedForColumn(hub, restriction)
      )
    }
    const workflowId = hub.data.workflowState?.id
    if (!workflowId || type !== onlyCheckObjectType) {
      return false
    }
    const workflow = this.get(workflowId)
    const config = workflowToConfig(workflow)
    return !!config?.restrict?.includes(restriction)
  }

  private static isDisallowedForColumn(
    column: Hub,
    restriction: Workflows.Restriction
  ): boolean {
    const workflows = this.getBoardWorkflows(column.location)
    for (const workflow of workflows) {
      const config = workflowToConfig(workflow)
      if (config?.restrict?.includes(restriction)) {
        return true
      }
    }
    return false
  }
}
